"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AICleaningInfo_1 = require("../model/AICleaningInfo");

var AICleaningInfoConverter_1 = require("./AICleaningInfoConverter");

var AICleaningInfoConverterImpl =
/*#__PURE__*/
function (_AICleaningInfoConver) {
  _inherits(AICleaningInfoConverterImpl, _AICleaningInfoConver);

  function AICleaningInfoConverterImpl() {
    _classCallCheck(this, AICleaningInfoConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(AICleaningInfoConverterImpl).apply(this, arguments));
  }

  _createClass(AICleaningInfoConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return Object.assign(Object.assign({}, conversions.classToDocumentId(source)), {
        date: conversions.fromDate(source.date),
        userId: source.userId
      });
    }
  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new AICleaningInfo_1.AICleaningInfo(conversions.documentToClassId(source), conversions.toDate(source.date), source.userId);
    }
  }]);

  return AICleaningInfoConverterImpl;
}(AICleaningInfoConverter_1.AICleaningInfoConverter);

exports.AICleaningInfoConverterImpl = AICleaningInfoConverterImpl;